import CodeIcon from '@mui/icons-material/Code';
import Support from '@mui/icons-material/ContactSupportOutlined';
import LogoutIcon from '@mui/icons-material/LogoutOutlined';
import Notification from '@mui/icons-material/NotificationsNoneOutlined';
import IconEditProfile from '@mui/icons-material/SettingsOutlined';
import { useTheme } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import GenericDrawer from '@/components/GenericDrawer';
import useResponsive from '@/hooks/useResponsive';
import { useAuth } from '@/providers/auth/use-auth';
import { RootState } from '@/redux/store';
import Developers from '@/sections/Developers';
import EditProfile from '@/sections/EditProfile';
import NotificationConfig from '@/sections/NotificationsConfig';

interface IProfileMenuOptionsProps {
  closeMenu: () => void;
  option: string;
  onChgOption: (option: string) => void;
}

export const ProfileMenuOptions = (props: IProfileMenuOptionsProps) => {
  const { logout: auth0Logout } = useAuth();
  const { closeMenu, option, onChgOption } = props;
  const navigate = useNavigate();
  const isMobile = useResponsive('between', 'xxs', 'xxl');
  const theme = useTheme();
  const { profile } = useSelector((state: RootState) => state.parcel);

  return (
    <>
      {profile.data && (
        <>
          <MenuItem
            onClick={() => {
              onChgOption('editProfile');
              closeMenu();
            }}
            sx={{
              padding: '1rem',
              ':hover': {
                backgroundColor: theme.palette.grey[50],
                svg: {
                  color: theme.palette.primary.main,
                },
              },
            }}
          >
            <IconEditProfile color="disabled" sx={{ mr: '0.5rem' }} />
            <Typography textAlign="center" fontWeight={theme.typography.fontWeightMedium}>
              Editar perfil{' '}
            </Typography>
          </MenuItem>
          <MenuItem
            onClick={() => {
              onChgOption('notifications');
              closeMenu();
            }}
            sx={{
              padding: '1rem',
              ':hover': {
                backgroundColor: theme.palette.grey[50],
                svg: {
                  color: theme.palette.primary.main,
                },
              },
            }}
          >
            <Notification color="disabled" sx={{ mr: '0.5rem' }} />
            <Typography textAlign="center" fontWeight={theme.typography.fontWeightMedium}>
              Configurar notificaciones
            </Typography>
          </MenuItem>
          <MenuItem
            onClick={() => {
              onChgOption('developers');
              closeMenu();
            }}
            sx={{
              padding: '1rem',
              ':hover': {
                backgroundColor: theme.palette.grey[50],
                svg: {
                  color: theme.palette.primary.main,
                },
              },
            }}
          >
            <CodeIcon color="disabled" sx={{ mr: '0.5rem' }} />
            <Typography textAlign="center" fontWeight={theme.typography.fontWeightMedium}>
              Developers
            </Typography>
          </MenuItem>

          <GenericDrawer
            open={option.length > 0}
            onClose={() => onChgOption('')}
            title={
              option === 'editProfile'
                ? 'Mis datos'
                : option === 'developers'
                  ? 'Developers'
                  : 'Notificaciones'
            }
            disableEscapeKeyDown={true}
            iconTitle={
              option === 'editProfile' ? (
                <IconEditProfile color="primary" />
              ) : option === 'developers' ? (
                <CodeIcon color="primary" />
              ) : (
                <Notification color="primary" />
              )
            }
          >
            {option === 'editProfile' ? <EditProfile /> : null}
            {option === 'notifications' ? <NotificationConfig /> : null}
            {option === 'developers' ? <Developers /> : null}
          </GenericDrawer>

          {isMobile && (
            <MenuItem
              onClick={() => {
                closeMenu();
                navigate('/support');
              }}
              sx={{
                padding: '1rem',
                ':hover': {
                  backgroundColor: theme.palette.grey[50],
                  svg: {
                    color: theme.palette.primary.main,
                  },
                },
              }}
            >
              <Support color="disabled" sx={{ mr: '0.5rem' }} />
              <Typography textAlign="center" fontWeight={theme.typography.fontWeightMedium}>
                FAQs
              </Typography>
            </MenuItem>
          )}
        </>
      )}
      <MenuItem
        onClick={() => {
          closeMenu();
          auth0Logout();
        }}
        sx={{
          padding: '1rem',
          ':hover': {
            backgroundColor: theme.palette.grey[50],
            svg: {
              color: theme.palette.primary.main,
            },
          },
        }}
      >
        <LogoutIcon color="disabled" sx={{ mr: '0.5rem' }} />
        <Typography textAlign="center" fontWeight={theme.typography.fontWeightMedium}>
          Cerrar sesión
        </Typography>
      </MenuItem>
    </>
  );
};
